import BackofficeEntityItemsBase from './BackofficeEntityItemsBase';

export default class BackofficeEntityProductsIndex extends BackofficeEntityItemsBase {
  constructor() {
    super('product');
  }

  bindEvents() {
    super.bindEvents();
    
    $("#file-import-input").dropify({
      messages: {
        'default': I18n.t('plugins.dropify.messages.default'),
        'replace': I18n.t('plugins.dropify.messages.replace'),
        'remove': I18n.t('plugins.dropify.messages.remove'),
        'error': I18n.t('plugins.dropify.messages.error')
      },
      error: {
        'fileSize': I18n.t('plugins.dropify.error.fileSize'),
        'minWidth': I18n.t('plugins.dropify.error.minWidth'),
        'maxWidth': I18n.t('plugins.dropify.error.maxWidth'),
        'minHeight': I18n.t('plugins.dropify.error.minHeight'),
        'maxHeight': I18n.t('plugins.dropify.error.maxHeight'),
        'imageFormat': I18n.t('plugins.dropify.error.imageFormat'),
        'fileExtension': I18n.t('plugins.dropify.error.fileExtension'),
      }
    });
  }
}